































import { ref, computed, defineComponent, onMounted, PropType } from '@vue/composition-api';
import { GameListItemType } from '../types';
import '../dropdown.stylus';

export default defineComponent({
    name: "select-game", // ICP备案主页面
    components: {

    },
    props: {
        data: {
            type: Array as PropType<GameListItemType[]>,
            default: () => []
        },
        appId: {
            type: String
        }
    },
    setup(props, context) {
        // 当前选中的游戏的信息
        const activeMiniGame = computed(() => {
            return props.data.find((item: GameListItemType) => item.appId === props.appId);
        })

        // 选中下拉菜单的里的值
        function command(item: GameListItemType) {
            context.emit('update-minigameId', item.appId);
        }

        onMounted(() => {
            context.emit('update-minigameId', props.data[0].appId);
        })
        return {
            activeMiniGame,
            command
        }
    },
})
